import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT, IMAGES, PRICE, winnerPoints } from '../data/offer';
import { Reveal } from './Reveal';
import { CheckIcon, ClockIcon } from './icons/CraftIcons';
import { CountdownDigits } from './CountdownDigits';
import { CtaButton } from './CtaButton';
const USD = '\u0024';
export function FinalCta() {
  return <section id="checkout" aria-labelledby="final-cta" className="relative w-full overflow-hidden bg-ink px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-88" data-mp="15fgialsjv51g">
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 right-0 hidden h-72 w-72 rounded-full bg-gold/15 blur-3xl sm:block" data-id="element-89" data-mp="1ed8z5udx6kqy" />
      <div className="relative mx-auto grid max-w-[1080px] items-center gap-7 sm:gap-10 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-90" data-mp="1o3bqlq5e7qn6">
        <Reveal className="perspective-stage order-2 lg:order-1" data-id="element-91" data-mp="224o2nqhfn83s">
          <div className="mx-auto w-full max-w-md" data-id="element-92" data-mp="1x4tcjp5hemjs">
            <motion.img src={IMAGES.bundle} alt="Everything included in the Modern Maker's Vault laid out: treasury book, tablet, workbook, phone and branding cards" className="w-full rounded-3xl border border-cream/10 object-cover shadow-deep" loading="lazy" decoding="async" width={1376} height={768} initial={{
            rotateY: -14,
            scale: 0.94,
            opacity: 0
          }} whileInView={{
            rotateY: -5,
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-93" data-mp="1x64i9uihm4dj" />

            <div className="mt-5 sm:mt-6" data-id="element-94" data-mp="1fvb8givoca52">
              <CtaButton size="lg" isCheckout href={CHECKOUT.url} label={`YES! GIVE ME THE ${USD}${PRICE.totalValue} TREASURY FOR ONLY ${USD}${PRICE.today}`} subLabel="Instant PDF access · One-time payment · 30-day refund" data-id="element-95" data-mp="1fwcvllpysn35" />
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2" data-id="element-96" data-mp="3qvgty8og6xgq">
          <Reveal data-id="element-97" data-mp="3lvko03w6wvyj">
            <span className="inline-flex items-center gap-2 rounded-full border border-crimson/40 bg-crimson/15 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-crimson-tint" data-id="element-98" data-mp="3lw45xklubkck">
              <ClockIcon className="h-3.5 w-3.5" data-id="element-99" data-mp="3uvqydgwldfth" />
              Closes in <CountdownDigits className="text-[11px]" data-id="element-100" data-mp="3uu647se6vyw5" />
            </span>
            <h2 id="final-cta" className="mt-4 font-display text-3xl font-bold leading-tight text-cream sm:text-[40px]" data-id="element-101" data-mp="de7p9swn6zd2">
              Don&rsquo;t be the one who missed out.
            </h2>

            <ul className="mt-5 space-y-2.5 sm:mt-6" data-id="element-102" data-mp="me4j08xw2oez">
              {winnerPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-sm text-cream/80" data-id="element-103" data-mp="id171xiypcj1">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" data-id="element-104" data-mp="2o9nbcn4hrkui" />
                  {point}
                </li>)}
            </ul>

            <div className="mt-6 flex items-end gap-4 sm:mt-7" data-id="element-105" data-mp="2a3lcdqnvwt82">
              <p className="font-display text-5xl font-extrabold leading-none text-gold-light" data-id="element-106" data-mp="2e3ncvwhvvglr">
                {USD}
                {PRICE.today}
              </p>
              <div className="pb-1" data-id="element-107" data-mp="20ae8ybcpfnam">
                <p className="text-xs font-bold uppercase tracking-wide text-cream/60 line-through" data-id="element-108" data-mp="25b1wuo5mzo0m">
                  {USD}
                  {PRICE.totalValue}.00 value
                </p>
                <p className="text-[11px] font-extrabold uppercase tracking-wide text-sage-tint" data-id="element-109" data-mp="1vd5scf77frbh">
                  You save {USD}
                  {PRICE.savings}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      <p className="relative mx-auto mt-10 max-w-3xl border-t border-cream/10 pt-6 text-center text-[11px] text-cream/45 sm:mt-14" data-id="element-110" data-mp="1metqti4sv949">
        The Ultimate Crochet Treasury 2026 · Digital download only, no physical product is shipped ·
        Commercial license included with purchase.
      </p>
    </section>;
}